import { render, staticRenderFns } from "./PromotionalIneligible.vue?vue&type=template&id=4abe4f29"
import script from "./PromotionalIneligible.vue?vue&type=script&lang=js"
export * from "./PromotionalIneligible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports